import { render, staticRenderFns } from "./AgentMenu.vue?vue&type=template&id=6e4a979f&scoped=true&"
import script from "./AgentMenu.vue?vue&type=script&lang=js&"
export * from "./AgentMenu.vue?vue&type=script&lang=js&"
import style0 from "./AgentMenu.vue?vue&type=style&index=0&id=6e4a979f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a979f",
  null
  
)

export default component.exports